import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles, Typography } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import moment from 'moment';
import 'moment/locale/de';

class DayStepper extends Component {
  render() {
    moment.locale('de');
    const { classes } = this.props;

    if (!this.props.value) return null;

    return (
      <div className={classes.root}>
        <div
          className={classes.divButton}
          aria-label="Left"
          onClick={() => this.props.onChange(moment(this.props.value).add(-1, 'days'))}
        >
          <ChevronLeft fontSize="default" />
        </div>
        <Typography className={classes.textContainer}>
          {moment(this.props.value).format('dd D. MMM')}
        </Typography>

        <div
          className={classes.divButton}
          aria-label="Right"
          onClick={() => this.props.onChange(moment(this.props.value).add(1, 'days'))}
        >
          <ChevronRight fontSize="default" />
        </div>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.appbar.buttons.fontSize,
    // fontFamily: "Roboto" | "Helvetica" | "Arial" | "sans-serif",
    fontWeight: '425',
    // lineHeight: "1.75",
    // whiteSpace: "normal",
    // letterSpacing: "0.02857em",
  },
  divButton: {
    display: 'flex',
    alignItems: 'center',
  },
});

DayStepper.propTypes = {
  value: PropTypes.object,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

DayStepper.defaultProps = {
  value: new Date(),
  onChange: () => { },
};

export default withStyles(styles)(DayStepper);
